import "./globalCapabilityHero.css";
import gcHeroImage from "../../../assets/services/gc-hero.webp";

const GlobalCapabilityHero = () => {
  return (
    <section className="gc-hero">
      <div className="gc-hero__media" aria-hidden="true">
        <img
          src={gcHeroImage}
          alt="Professionals collaborating in a modern workspace"
          className="gc-hero__image"
          fetchPriority="high"
        />
        <div className="gc-hero__shade" />
        <div className="gc-hero__grid" />
        <div className="gc-hero__scan" />
      </div>

      <span className="gc-hero__corner gc-hero__corner--tl" aria-hidden="true" />
      <span className="gc-hero__corner gc-hero__corner--br" aria-hidden="true" />

      <div className="gc-hero__container">
        <div className="gc-hero__content">
          <span className="gc-hero__eyebrow">
            GLOBAL CAPABILITY SERVICES
          </span>

          <h1 className="gc-hero__title">
            Build the Team.
            Strengthen Operations.
            <br />
            <span>Scale with Confidence.</span>
          </h1>

          <p className="gc-hero__description">
            Qualitas Global helps businesses extend their capabilities through
            flexible staffing, knowledge process outsourcing, business process
            outsourcing, and build-operate-transfer solutions. Choose the
            support you need to strengthen delivery, access specialized
            expertise, and scale operations around your business goals.
          </p>

          <div className="gc-hero__actions">
            <a href="/contact-us" className="gc-hero__button gc-hero__button--primary">
              Discuss Your Requirements
              <span aria-hidden="true">↗</span>
            </a>

            <button
              type="button"
              className="gc-hero__button gc-hero__button--secondary"
              onClick={() =>
                document
                  .getElementById("gc-services")
                  ?.scrollIntoView({ behavior: "smooth", block: "start" })
              }
            >
              Explore Our Services
              <span aria-hidden="true">↓</span>
            </button>
          </div>
        </div>

        <div className="gc-hero__visual" aria-hidden="true">
          <svg className="gc-hero__globe" viewBox="0 0 600 600" focusable="false">
            <defs>
              <radialGradient id="gc-hero-core" cx="50%" cy="46%" r="52%">
                <stop offset="0%" stopColor="#ff6b00" stopOpacity="0.28" />
                <stop offset="60%" stopColor="#ff6b00" stopOpacity="0.06" />
                <stop offset="100%" stopColor="#ff6b00" stopOpacity="0" />
              </radialGradient>
              <clipPath id="gc-hero-clip">
                <circle cx="300" cy="300" r="220" />
              </clipPath>
            </defs>

            <circle cx="300" cy="300" r="290" fill="url(#gc-hero-core)" />
            <circle className="gc-hero__ring gc-hero__ring--a" cx="300" cy="300" r="290" />
            <circle className="gc-hero__ring gc-hero__ring--b" cx="300" cy="300" r="250" />
            <circle className="gc-hero__sphere" cx="300" cy="300" r="220" />

            <g clipPath="url(#gc-hero-clip)">
        <ellipse className="gc-hero__lat" cx="300" cy="405" rx="110" ry="18" />
        <ellipse className="gc-hero__lat" cx="300" cy="360" rx="191" ry="30" />
        <ellipse className="gc-hero__lat" cx="300" cy="300" rx="220" ry="35" />
        <ellipse className="gc-hero__lat" cx="300" cy="240" rx="191" ry="30" />
        <ellipse className="gc-hero__lat" cx="300" cy="195" rx="110" ry="18" />
        <ellipse className="gc-hero__mer" style={{ animationDelay: "-0s" }} cx="300" cy="300" rx="220" ry="220" />
        <ellipse className="gc-hero__mer" style={{ animationDelay: "-2s" }} cx="300" cy="300" rx="220" ry="220" />
        <ellipse className="gc-hero__mer" style={{ animationDelay: "-4s" }} cx="300" cy="300" rx="220" ry="220" />
        <ellipse className="gc-hero__mer" style={{ animationDelay: "-6s" }} cx="300" cy="300" rx="220" ry="220" />
        <ellipse className="gc-hero__mer" style={{ animationDelay: "-8s" }} cx="300" cy="300" rx="220" ry="220" />
        <ellipse className="gc-hero__mer" style={{ animationDelay: "-10s" }} cx="300" cy="300" rx="220" ry="220" />
              <line className="gc-hero__axis" x1="300" y1="70" x2="300" y2="530" />
            </g>

        <path className="gc-hero__arc" style={{ animationDelay: "-0.0s" }} d="M360 205 Q327 316 235 245" />
        <path className="gc-hero__arc" style={{ animationDelay: "-1.1s" }} d="M360 205 Q334 282 415 290" />
        <path className="gc-hero__arc" style={{ animationDelay: "-2.2s" }} d="M235 245 Q294 313 225 370" />
        <path className="gc-hero__arc" style={{ animationDelay: "-3.3s" }} d="M335 335 Q414 382 415 290" />
        <path className="gc-hero__arc" style={{ animationDelay: "-4.4s" }} d="M275 150 Q344 137 360 205" />
        <path className="gc-hero__arc" style={{ animationDelay: "-5.5s" }} d="M235 245 Q211 179 275 150" />
        <path className="gc-hero__arc" style={{ animationDelay: "-6.6s" }} d="M335 335 Q261 292 225 370" />

        <g className="gc-hero__city" style={{ animationDelay: "-0.0s" }}>
          <circle className="gc-hero__ping" cx="360" cy="205" r="5" />
          <circle className="gc-hero__dot" cx="360" cy="205" r="3.5" />
        </g>
        <g className="gc-hero__city" style={{ animationDelay: "-0.7s" }}>
          <circle className="gc-hero__ping" cx="235" cy="245" r="5" />
          <circle className="gc-hero__dot" cx="235" cy="245" r="3.5" />
        </g>
        <g className="gc-hero__city" style={{ animationDelay: "-1.4s" }}>
          <circle className="gc-hero__ping" cx="335" cy="335" r="5" />
          <circle className="gc-hero__dot" cx="335" cy="335" r="3.5" />
        </g>
        <g className="gc-hero__city" style={{ animationDelay: "-2.1s" }}>
          <circle className="gc-hero__ping" cx="275" cy="150" r="5" />
          <circle className="gc-hero__dot" cx="275" cy="150" r="3.5" />
        </g>
        <g className="gc-hero__city" style={{ animationDelay: "-2.8s" }}>
          <circle className="gc-hero__ping" cx="415" cy="290" r="5" />
          <circle className="gc-hero__dot" cx="415" cy="290" r="3.5" />
        </g>
        <g className="gc-hero__city" style={{ animationDelay: "-3.5s" }}>
          <circle className="gc-hero__ping" cx="225" cy="370" r="5" />
          <circle className="gc-hero__dot" cx="225" cy="370" r="3.5" />
        </g>

            <g className="gc-hero__orbiter gc-hero__orbiter--a">
              <circle cx="300" cy="10" r="5" />
            </g>
            <g className="gc-hero__orbiter gc-hero__orbiter--b">
              <circle cx="550" cy="300" r="4" />
            </g>
          </svg>
        </div>
      </div>

      <span className="gc-hero__line" aria-hidden="true" />
    </section>
  );
};

export default GlobalCapabilityHero;
